import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

let styles;

const FooterItem = props => (
  <Link to={props.url}>
    <div className={css(styles.container, props.styles)}>{props.title}</div>
  </Link>
);

export default FooterItem;

FooterItem.propTypes = {
  url: PropTypes.string.isRequired,
  styles: PropTypes.arrayOf(PropTypes.array),
  title: PropTypes.string.isRequired,
};

FooterItem.defaultProps = {
  styles: [],
};

styles = StyleSheet.create({
  container: {
    color: Theme.white,
    fontFamily: Theme.font_family_primary,
    fontSize: Theme.footer.font_size,
    fontWeight: Theme.font_weight_primary,
    marginBottom: 16,
    transition: 'all 150ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/FooterItem/index.js